<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>Reporte de grupos
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-15">
      <div class="card-body">
        <div class="row">
          <div class="col-lg-12">
            <div class="table-responsive">
              <table class="table table-hover mb-0">
                <thead class="thead-default">
                  <tr>
                    <th>Código/Fecha</th>
                    <th>Tour/destino</th>
                    <th>Transporte</th>
                    <th>Guia</th>
                    <th class="text-center">N° Pax</th>
                    <th class="text-center">T.Operativo</th>
                    <th class="text-center">T.Gastos</th>
                    <th class="text-center">Ref.Utilidad</th>
                    <th class="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngIf="items.length == 0">
                    <td colspan="2"><span>No se encontraron registros</span></td>
                  </ng-container>
                  <ng-container *ngIf="items.length > 0">
                    <tr
                      *ngFor="let item of items | paginate: { itemsPerPage: dataPagination.pageSize, currentPage: dataPagination.currentPage, totalItems:dataPagination.totalItems }; let i = index">
                      <td class="nowrap">
                        <span class="bold f-s-12">{{item.code}}</span>
                        <p class="f-s-9 m-b-0">{{item.date_departure}}</p>
                        <ng-container *ngIf="item.is_balance">
                          <p class="f-s-9 m-b-0"><span class="badge badge-success">Balance realizado</span></p>
                        </ng-container>
                      </td>
                      <td>{{item.tour_data.description}}</td>
                      <td>{{item.transport_data.owner}}</td>
                      <td>{{item.guide_data.fullname}}</td>
                      <td class="text-center">{{item.capacity_selected}}</td>
                      <td class="text-center">{{item.total_operational}}</td>
                      <td class="text-center">{{item.total_expense}}</td>
                      <td class="text-center text-primary bold">{{item.total_operational - item.total_expense}}</td>
                      <td class="text-center nowrap">
                        <a href="/{{branchofficeSlug}}/api/groups/list/export/{{item.date_departure}}/{{item.tour_id}}"
                        class="btn btn-small btn-default f-s-15 m-r-5" target="_blank" style="padding: 1px 5px;"><i
                          class="far fa-file-pdf text-danger"></i> 
                        </a>
                        <ng-container *ngIf="!item.is_balance">
                          <button class="btn btn-outline-info btn-sm f-s-10 p-t-2 p-b-2" (click)="balance(item.id)">Balance<i class="fas fa-arrow-right m-l-2"></i></button>
                        </ng-container>                        
                      </td>                     
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
            <div class="col-md-12 ">
              <div class="row content_pagination">
                <div class="col-lg-4">
                  <p class="pagination__label">Total <span class="bold">{{dataPagination.totalItems}}</span> registros.
                  </p>
                </div>
                <div class="text-right col-lg-8">
                  <ng-container *ngIf="items.length > 0">
                    <app-pagination (paginateEvent)="handlePageChange($event)"></app-pagination>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
